import { render } from "./createTermLetterDialog.vue?vue&type=template&id=b687c458"
import script from "./createTermLetterDialog.vue?vue&type=script&lang=js"
export * from "./createTermLetterDialog.vue?vue&type=script&lang=js"

import "./createTermLetterDialog.vue?vue&type=style&index=0&id=b687c458&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__